import React, { useEffect } from 'react';
import './AlertModal.scss';

function AlertModal({
  show,
  message,
  type = 'alert',
  onConfirm,
  onCancel,
  confirmText = '확인',
  cancelText = '취소',
}) {
  useEffect(() => {
    if (show) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [show]);

  if (!show) return null;

  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm();
    }
  };

  const handleCancel = () => {
    if (onCancel) {
      onCancel();
    }
  };

  return (
    <div className="alert-modal-overlay">
      <div className="alert-modal-dialog">
        <div className="alert-modal-body">
          <div className="alert-modal-message">{message}</div>
          <div className="alert-modal-button-container">
            {type === 'confirm' && (
              <button
                className="alert-modal-cancel-button"
                onClick={handleCancel}
              >
                {cancelText}
              </button>
            )}
            <button
              className="alert-modal-confirm-button"
              onClick={handleConfirm}
            >
              {confirmText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AlertModal;
